import { render } from 'preact';
import './styles/base.css';
import { App } from './app';
import { watchFocusMode } from './lib/focusMode';

watchFocusMode();

render(<App />, document.getElementById('app')!);
